module.exports = __webpack_public_path__ + "img/img-bf2b8817.98b96673.png";